import React, {useEffect, useRef} from 'react';

import styles from "./Burger.module.scss";

export default function Burger({opened}) {
    const burger = useRef(null);

    useEffect(() => {
        const introduction = document.querySelector('[class*=Introduction2_Main]')
        window.addEventListener('scroll', () => {
            if (introduction.getBoundingClientRect().bottom <= 0) {
                burger.current.classList.add('black');
            } else {
                burger.current.classList.remove('black');
            }
        })
    }, []);

    return (
        <span className={[styles.Main, opened ? 'opened' : ''].join(' ')} ref={burger}>
            <span/>
            <span/>
            <span/>
        </span>
    )
}
